import React, { useEffect, useState } from 'react';
import ModalMenu from '/Foundation/Common/code/Views/Foundation/Common/ModalMenu';
import Notification from '/Foundation/Common/code/Views/Foundation/Common/Notifications/Notification.js';

const Orderline = (props) => {
  const { ol, i, isReturned, setOrderLines, orderLines, Translations, ReturnReasons } = props;

  const [showModal, setShowModal] = useState(false);
  const [selectedQty, setSelectedQty] = useState(null);
  const [selectedReason, setSelectedReason] = useState(null);

  //Used for updating orderlines with new values
  const OrderLineKeys = Object.freeze({
    QuantityError: 'QuantityError',
    ReturnReasonError: 'ReturnReasonError',
    QuantityToReturn: 'QuantityToReturn',
    ReturnReason: 'ReturnReason',
  });

  useEffect(() => {
    if (!ol.QuantityToReturn) {
      setSelectedQty(null);
      setSelectedReason(null);
    }
  }, [orderLines]);

  const validateData = () => {
    const updatedLines = updateOrderLines(
      [
        {
          key: OrderLineKeys.QuantityError,
          value: !validateQuantity(selectedQty.Value),
        },
        {
          key: OrderLineKeys.QuantityToReturn,
          value: selectedQty.Value,
        },
        {
          key: OrderLineKeys.ReturnReasonError,
          value: !validateReturnReason(selectedReason.Value),
        },
        {
          key: OrderLineKeys.ReturnReason,
          value: selectedReason.Value,
        },
      ],
      i
    );
    setOrderLines(updatedLines);
    setTimeout(() => {
      setShowModal(false);
    }, 300);
  };

  const validateQuantity = (quantity) => {
    return !isNaN(quantity);
  };

  const validateReturnReason = (reason) => {
    return reason?.length > 0;
  };

  const updateOrderLines = (input, index) => {
    let lines = [...orderLines];
    let line = { ...lines[index] };

    // Mutates the orderline with the input key and value
    for (let i = 0; i < input.length; i++) {
      line[input[i].key] = input[i].value;
    }

    lines[index] = line;
    return lines;
  };

  const getModalContent = () => {
    if (!showModal) return null;

    let options,
      step,
      placeholder,
      mainTitle,
      stepBack,
      setSelectedItem,
      hideSearch,
      primaryButtonText,
      primaryButtonAction,
      secondaryButtonText,
      secondaryButtonAction,
      applySelectedItemStyling;
    if (!selectedQty) {
      let qtyOptions = Array.from({ length: ol.QuantityLeft }, (_, i) => ({ Name: i + 1, Value: i + 1 }));
      if (ol.QuantityLeft == 1) {
        setSelectedQty(qtyOptions[0]);
      } else {
        qtyOptions.unshift({ Name: Translations.All, Value: ol.QuantityLeft });

        setSelectedItem = setSelectedQty;
        mainTitle = Translations.SelectQuantity;
        placeholder = Translations.SearchPlaceholder;
        options = qtyOptions;
        step = 1;
        hideSearch = qtyOptions?.length <= 12;
      }
    } else {
      let returnReasons = [];
      Object.entries(ReturnReasons).map((reason) =>
        returnReasons.push({
          Value: reason[0],
          Name: reason[1],
        })
      );
      setSelectedItem = setSelectedReason;
      stepBack =
        ol.QuantityLeft == 1
          ? null
          : (e) => {
              setSelectedQty(null);
            };
      mainTitle = Translations.SelectReason;
      options = returnReasons;
      step = 2;
      hideSearch = true;
      primaryButtonText = Translations.Confirm;
      primaryButtonAction = validateData;
      secondaryButtonText = Translations.Cancel;
      secondaryButtonAction = () => setShowModal(false);
      applySelectedItemStyling = true;
    }

    return (
      <ModalMenu
        setSelectedItem={setSelectedItem}
        stepBack={stepBack}
        mainTitle={mainTitle}
        placeholder={placeholder}
        close={() => {
          setTimeout(() => {
            setShowModal(false);
          }, 300);
        }}
        steps={2}
        step={step}
        options={options}
        hideSearch={hideSearch}
        primaryButtonText={primaryButtonText}
        primaryButtonAction={primaryButtonAction}
        secondaryButtonText={secondaryButtonText}
        secondaryButtonAction={secondaryButtonAction}
        applySelectedItemStyling={applySelectedItemStyling}
      />
    );
  };

  return (
    <article className={`orderline ${!ol.IsReturnable ? 'disabled' : ''} d-lg-flex p-3 p-lg-4`}>
      <div className="product-image me-lg-5 me-xl-6 mb-6 mb-lg-0">
        {ol.Image && <img src={ol.Image} alt={ol.ImageAlt || ol.Title} />}
      </div>

      <div className="orderline-body d-flex">
        <div className="product-details d-flex">
          <div>
            <h5 className="heading5 mb-3">{ol.Title}</h5>
            <div className="paragraph--s mb-2 text-color--gray70">
              {Translations.ModelNumber}: <span>{isReturned ? ol.Sku : ol.SKUNumber}</span>
            </div>
            <div className="paragraph--s mb-2 text-color--gray70">
              {Translations.Color}: <span>{ol.Color}</span>
            </div>
            {isReturned && (
              <div className="paragraph--s mb-2 text-color--gray70">
                {Translations.Quantity}: <span>{ol.Quantity}</span>
              </div>
            )}
            {!isReturned && (
              <div className="paragraph--s mb-2 text-color--gray70">
                {Translations.Quantity}:{' '}
                <span>
                  {ol.Quantity} ({Translations.Withdrawn} {ol.QuantityWithdrawn} {Translations.Returned}{' '}
                  {ol.QuantityReturned})
                </span>
              </div>
            )}
          </div>
          <div>
            <span className="product-price-value heading6 ms-3">{isReturned ? ol.Total : ol.LineTotal}</span>
          </div>
        </div>

        {!isReturned && (
          <>
            {!ol.IsReturnable && (
              <div className="d-flex already-returned">
                <i className="le-icon-info"></i>
                <span className="heading6">{Translations.NotReturnableMessage}</span>
              </div>
            )}
            {ol.IsReturnable && (
              <div className="product-selection-button d-flex mt-6 mt-lg-0" onClick={() => setShowModal(true)}>
                {
                  <i
                    className={`selection-indicator fit-indicator ${ol.QuantityToReturn > 0 ? 'le-icon-check-circle confirmed' : 'le-icon-plus-circle'}`}
                  ></i>
                }
                <span className={`heading6 text-color--black fit-guide-span ms-3`}>
                  {ol.QuantityToReturn > 0
                    ? `${ol.QuantityToReturn} ${Translations.SelectedProducts}`
                    : Translations.SelectProduct}
                </span>
              </div>
            )}
          </>
        )}
      </div>
      {getModalContent()}
    </article>
  );
};

export default Orderline;
